import * as React from 'react';
import './index.css';
import { withTranslation } from '@sailor/i18n-mach-pro';
import { connect } from '@wmfe/mach-pro-store';
import { reportBizCardMetrics, findTargetFromMatrix } from '@/src/utils/bizCardReporter';
import {
  LxFilterParams, reportProductCardMc, reportProductCardMv, reportProductMv, reportProductMc
} from './lxReport';
import ShopCard from './card_container';
import { StoreDepType, ShopCardWithDishesDataType, PuzzleComponent } from './interface';

const mapStateToProps = (state: StoreDepType) => ({
  // filterPanelData: state.global?.filterPanelData,
  feedAPIData: state.global?.feedAPIData,
  pageNo: state.global?.pageNo,
});

type IProps = ReturnType<typeof mapStateToProps> & { apiData: PuzzleComponent<ShopCardWithDishesDataType>; bizTraceId: string; pageLogData?: any; }

interface IState {
}

class FeedsShopCardWithDishes extends React.Component<IProps, IState> {
  cardWidth: number = 0
  keyDomRef: any = null;
  observer: any = null;

  constructor(props) {
    super(props);
  }

  /**
     * 曝光监听
     */
  observerCellAppear = () => {
    this.removeObserver();
    if (globalThis?.eventBus?.subscribeCellAppear) { // 新主包通过监听appear通知上报MV
      this.observer = globalThis?.eventBus?.subscribeCellAppear?.(this.props.apiData?.indexPath, () => {
        this.lxReportOnShow(this.props.apiData);
      });
    } else { // 兼容旧主包
      this.lxReportOnShow(this.props.apiData);
    }
  }

  isContenthasPrice = (content) => content?.find((item) => (item.find(((contentItem) => (contentItem?.type === 'spuPrice' && (contentItem?.data?.finalPrice?.displayText?.length > 0))))))

  reportCardMetrics = () => {
    const { json_data } = this.props.apiData || {};
    const tags = { channel: '店挂菜商卡' };
    if (!json_data) {
      return null;
    }
    reportBizCardMetrics(
      {
        params: {
          shopNameMissing: findTargetFromMatrix(json_data?.content, 'shopName')?.name ? 0 : 1,
          shopMainPicMissing: (json_data?.pictures?.[0]?.url || json_data?.shopMainPicUrl) ? 0 : 1,
          shopJumpUrlMissing: json_data?.scheme ? 0 : 1
        },
        tags
      }
    );
    if (json_data?.subCards?.length > 0) {
      let dishNameMissingNum = 0;
      let dishMainPicMissingNum = 0;
      let dishPriceMissingNum = 0;
      let dishJumpUrlMissingNum = 0;
      json_data?.subCards.forEach((item) => {
        dishNameMissingNum += (item && findTargetFromMatrix(item?.content, 'spuPrice')?.finalPrice?.displayText ? 0 : 1);
        dishMainPicMissingNum += (item?.pictures?.[0]?.url ? 0 : 1);
        dishPriceMissingNum += (this.isContenthasPrice(item?.content) ? 0 : 1);
        dishJumpUrlMissingNum += (item?.scheme ? 0 : 1);
      });
      reportBizCardMetrics(
        {
          params: {
            dishNameMissing: dishNameMissingNum === 0 ? 0 : 1,
            dishMainPicMissing: dishMainPicMissingNum === 0 ? 0 : 1,
            dishPriceMissing: dishPriceMissingNum === 0 ? 0 : 1,
            dishJumpUrlMissing: dishJumpUrlMissingNum === 0 ? 0 : 1,
          },
          tags
        }
      );
    }
  }

  removeObserver = () => {
    if (!this.observer) {
      return;
    }

    this.observer?.unSubscribe?.();
  }

  handleFilterParams = () => ({})
  // const { sortOptions, filterOptions } = this.props.filterPanelData?.json_data || {};
  // let sort_code = "";
  // let sort_name = "";
  // if (sortOptions) {
  //     sortOptions?.sortOptionValues?.forEach((item) => {
  //         if (item.isSelected) {
  //             sort_code = item.sortCode;
  //             sort_name = item.sortName;
  //         }
  //     })
  // }
  // let filter_code_array : string[] = [];
  // let filter_name_array : string[]  = [];
  // if (filterOptions) {
  //     filterOptions.forEach((filterOption) => {
  //         filterOption.filterOptionValues.forEach((item) => {
  //             if (item.isSelected) {
  //                 filter_code_array.push(item.filterId);
  //                 filter_name_array.push(item.filterDisplayName);
  //             }
  //         })
  //     })
  // }
  // let filter_code = filter_code_array.join(";");
  // let filter_name = filter_name_array.join(";");
  // let lxFilterParams: LxFilterParams = {
  //     sort_code,
  //     sort_name,
  //     filter_code,
  //     filter_name,
  // }
  // return lxFilterParams;

  lxReportOnClick = () => {
    const { pageLogData } = this.props;
    const lxFilterParams = this.handleFilterParams();
    const bizTraceId = this.props.bizTraceId || '-999';
    reportProductCardMc(this.props.apiData?.log_info?.cid, this.props.apiData?.json_data, this.props.apiData?.indexPath.item, bizTraceId, lxFilterParams, pageLogData);
  }

  lxReportOnShow = (apiData) => {
    const { json_data: data } = apiData || {};
    const { pageLogData } = this.props;
    if (data?.isMV) {
      return;
    }
    this.reportCardMetrics();
    // 由于外部传入的时 CloneDeep 的数据，在列表数据更新时会导致 isMv 标志丢失, 造成 MV 上报重复，所以需要在全局做 MV 上报记录
    const mvKey = `${apiData?.indexPath?.item}_key`;
    if (globalThis.shopCardWithDishesMVHistory === undefined) {
      globalThis.shopCardWithDishesMVHistory = {};
    }
    if (globalThis.shopDishesMVHistory === undefined) {
      globalThis.shopDishesMVHistory = {};
    }
    // 如果第一个卡片要被重新曝光了，证明筛选条件已经发生变化或发生刷新，需要清空全局历史上报记录
    if (apiData?.indexPath?.item === 0 && this.props.pageNo === 0) {
      // 第一个数据会进行多次渲染，防止多次清空
      if (!this.props.feedAPIData?.isClearHomeProductCardMVHistory) {
        globalThis.shopCardWithDishesMVHistory = {};
        globalThis.shopDishesMVHistory = {};
        this.props.feedAPIData.isClearHomeProductCardMVHistory = true;
      }
    }
    if (globalThis.shopCardWithDishesMVHistory[mvKey]) {
      return;
    }
    const lxFilterParams = this.handleFilterParams();
    const bizTraceId = this.props.bizTraceId || '-999';
    reportProductCardMv(this.props.apiData?.log_info?.cid, this.props.apiData?.json_data, this.props.apiData?.indexPath?.item, bizTraceId, lxFilterParams, pageLogData);
    this.lxReportProductMv(apiData, this.props.apiData?.indexPath?.item);
    data.isMV = true;
    globalThis.shopCardWithDishesMVHistory[mvKey] = true;
  }
  lxReportProductMv = (apiData: PuzzleComponent<ShopCardWithDishesDataType>, cardIndex: number, scrollx?: number) => {
    const { pageLogData } = this.props;
    const cardWidth = this.cardWidth || (Mach.env.screenWidth - 12);
    const initMVProductCount = Math.floor((cardWidth + (scrollx || 0)) / 110);

    const subCards = apiData?.json_data?.subCards || [];
    const cid = this.props.apiData?.log_info?.cid;
    if (!subCards.length) return;
    subCards.forEach((item, index) => {
      if (index >= initMVProductCount) return;
      const cacheKey = `${cardIndex}_${index}`;
      if ((globalThis.shopDishesMVHistory || {})[cacheKey]) return;
      const productLogData = item?.logData || {};
      reportProductMv({ cid, logData: { ...productLogData, ...pageLogData, item_index: index } });
      globalThis.shopDishesMVHistory[cacheKey] = true;
    });
  }
  handleProductClick = (productItem, index) => {
    const { pageLogData } = this.props;
    const cid = this.props.apiData?.log_info?.cid;
    const logData = productItem?.logData || {};
    reportProductMc({ cid, logData: { ...logData, ...pageLogData, item_index: index } });
  }
  handleProductScrollEnd = (scrollx: number) => {
    const apiData = this.props?.apiData;
    this.lxReportProductMv(apiData, apiData?.indexPath?.item, scrollx);
  }
  render() {
    this.observerCellAppear();
    const { json_data, layout_info } = this.props.apiData || {};
    const {
      margin_top, margin_bottom, margin_left, margin_right
    } = layout_info || {};
    const itemKey = `itemKey${this.props.apiData?.indexPath?.item}`;
    return (
      <view
        key={itemKey}
        className="container"
        style={{ marginTop: margin_top || 0, marginBottom: margin_bottom || 12 }}
        onLayout={(frame) => {
          this.cardWidth = frame?.detail?.width;
        }}
      >
        <ShopCard
          data={json_data}
          layoutInfo={layout_info}
          lxReportOnClick={this.lxReportOnClick}
          productOnClick={this.handleProductClick}
          productOnScrollEnd={this.handleProductScrollEnd}
        />
      </view>
    );
  }
}

export default connect(mapStateToProps)(withTranslation('', {
  withRef: true
})(FeedsShopCardWithDishes));
